import { Outlet } from "react-router"

export default function MobileLayout() {
  return (
    <div className="bg-backdrop mx-auto max-w-md">
      <Outlet />
    </div>
  )
}
